import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
  signal
} from "@angular/core";
import { ReportDesignItemSignatureValue } from "../../report-design-item";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { UserBackend } from "src/app/backend/api/user.backend";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { lastValueFrom, map } from "rxjs";
import { HealthRecord } from "src/app/backend/models/health-record";
import { MemberLight } from "src/app/backend/models/member/member";
import { compact } from "lodash";

@Component({
  selector: "snt-report-form-renderer-signature",
  templateUrl: "report-form-renderer-signature.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererSignatureComponent implements OnInit {
  @Input({ required: true })
  item!: ReportDesignItemSignatureValue;

  @Input({ required: true })
  healthRecord!: HealthRecord | undefined;

  @Input()
  dataSource?: Record<string, any>;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Output()
  value: EventEmitter<void> = new EventEmitter();

  align = signal<"left" | "center" | "right" | undefined>(undefined);
  signatureHtml = signal<SafeHtml[] | undefined>(undefined);

  private readonly memberBackend = inject(MemberBackend);
  private readonly userBackend = inject(UserBackend);
  private readonly domSanitizer = inject(DomSanitizer);

  async ngOnInit(): Promise<void> {
    this.align.set(
      <"left" | "center" | "right" | undefined>this.item.config?.align
    );

    if (this.item.config?.user) {
      switch (this.item.config.user) {
        case "authors": {
          const signatures: string[] = compact(
            await Promise.all(
              (this.healthRecord?.staff || this.dataSource?.staff || []).map(
                (staff: { id: string }) => {
                  return lastValueFrom(
                    this.memberBackend
                      .loadLight(staff.id)
                      .pipe(
                        map((member: MemberLight) => member.signature || "")
                      )
                  );
                }
              ) || []
            )
          );

          this.signatureHtml.set(
            signatures.map((signature) =>
              this.domSanitizer.bypassSecurityTrustHtml(signature)
            )
          );

          break;
        }
        case "current-user": {
          const user = await lastValueFrom(this.userBackend.loadMe());

          this.signatureHtml.set([
            this.domSanitizer.bypassSecurityTrustHtml(user.signature || "")
          ]);
          break;
        }
        default: {
          const member = await lastValueFrom(
            this.memberBackend.loadLight(this.item.config.user)
          );

          this.signatureHtml.set([
            this.domSanitizer.bypassSecurityTrustHtml(member.signature || "")
          ]);
          break;
        }
      }
    }
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "signature",
      config: {
        signature: "",
        value: ""
      }
    };
  }
}
